import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer id='anti-fraud-efforts-make-the-call'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'>
          Make the call
        </Typography>
        <Typography nextElement='typography'>
          If you are an employee, contractor, field force member, or vendor&#47;supplier for Northwestern Mutual or its subsidiaries and you suspect or observe a concern related to possible:
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: 'Accounting irregularity' },
            { bulletText: 'Violation of business conduct or law' },
            { bulletText: 'Harassment' },
          ]} />
        <Typography nextElement='typography'>
          Contact the Ethics Resource Center (ERC) to confidentially report your concern. Help maintain an ethical culture and protect Northwestern Mutual&#39;s reputation for integrity and trust.
        </Typography>
        <Typography disableBottomPadding>
          Access the ERC by phone&nbsp;
          <Link
            id='anti-fraud-efforts-investment-services-phone-make-the-call-link'
            variant='primaryDeemphasize'
            linkUrl='tel:8666638427'>
            (866&#45;663&#45;8427)
          </Link> 8 a.m.&#8211;4 p.m. Central Time. Outside of business hours, you may leave a confidential message.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
